import React, { Component } from 'react'
import { Table, Card, Form, Icon, Spin, Button, Tooltip, Modal, Col, Row, DatePicker, Select, Pagination } from 'antd';
import { openNotification } from '../../../util/notificaciones';
import moment from 'moment'
import 'moment/locale/es';
// import PedidosPerfectosRequest from '../../services/ReportePedidosPerfectos';
import * as ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import CatalogoRequest from '../../../services/Catalogo';
import ReporteRequest from '../../../services/Reportes';
import { roles } from '../../../util/Roles';
import { get_id } from '../../../util/IdUser';
import MyTable from './MyTable';
import { esBarras, getSegmento } from '../../../util/generics';

moment.locale('es')

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const rol = localStorage.getItem("role")?.split(",");

/**
 * Clase para visualizar los pedidos realizados
 */
class Mermas extends Component {
    state = {
        esBarra: esBarras(),
        arrDrives: [],
        arrResultado: [],
        cargando: false,
        filterTextPedidos: "",
        estatusSelected: undefined,
        fechaPedido: [],
        datesPedido: [],
        datesVencimiento: [],
        objPedidoSelected: null,
        tipo_modal: "Recibir",
        disableDeleteFilters: true,
        paginacion: {},
        mostrarModalDetalle: false,
        arrResultadoVista: [],
        tiposMerma: [
            { id: 1, name: 'Merma Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 2, name: 'Merma Producto Terminado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 3, name: 'Mermas Consumo Empleado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 4, name: 'Mermas App Móvil', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 5, name: 'Mermas UberEats', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 6, name: 'Mermas Capacitación Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 7, name: 'Mermas Capacitación Producto Terminado (PT)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 8, name: 'Merma Lavado Equipo', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 9, name: 'Mermas Rappi (RAPPI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 10, name: 'Mermas Degustación (DEGU)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 11, name: 'Mermas Didi (DIDI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 12, name: 'Merma Entrega Cliente (INSMEC)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false }
        ],
        total: 0,
        pageSize: 100,
        tipoConsultaSelected: null,
        driveSelected: null,
        columnas: [],
        encabezado: {},
        cargandoFiltros: false,
        cargandoExcel: false,
        roles: localStorage.getItem("role")?.split(","),
        firstDate: null,
    }

    /**
     * Comportamiento del componente al recibir nuevos datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        const segmento = getSegmento()
        if (!segmento) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            state.cargandoFiltros = true;

            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                state.arrDrives = response.data
                let fecha = new Date();
                fecha.setHours(fecha.getHours() - 5);
                state.FechaStr = fecha.toLocaleDateString();
                state.cargandoFiltros = false;
                this.setState(state, () => {
                    if (!response.data.length) {
                        if (rol.includes(roles.Operador)) {
                            const mensaje = state.esBarra
                                ? "El usuario no tiene asignada una barra, favor de contactar al Administrador."
                                : "El usuario no tiene asignado un punto de venta, favor de contactar al Administrador."
                            openNotification(
                                mensaje,
                                "Error"
                            )
                        } else {
                            const aviso = state.esBarra
                                ? "El usuario no tiene asignada una barra, deberá configurarla en el módulo de usuarios."
                                : "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios."
                            openNotification(
                                aviso,
                                "Aviso"
                            )
                        }
                    }
                })
            }).catch(err => {
                const mensajeError = state.esBarra
                    ? "Ha ocurrido un error al listar las barras del usuario."
                    : "Ha ocurrido un error al listar los puntos de venta del usuario."
                openNotification(
                    mensajeError,
                    "Error"
                )
            })
        }
    }

    /**
     * Función para procesar las entradas de texto y eliminar espacios así como
     * caracteres especiales
     * @param: input. entrada de texto al select
     * @param: option. opciones para el filtrado
     * @return: Booleano que indica si la opcion contiene al input
     */
    sanitizerTexto = (input, option) => {
        return option.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
            .toLowerCase().includes(input.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())
    }

    /**
    * Se ejecuta cuando se van a realizar filtrados
    */
    applyFilters = () => {
        this.setState({tiposMerma : []});
        let state = { ...this.state };
        let filtros = {};
        if (state.filterTextPedidos.trim() === "" &&
            state.estatusSelected === undefined &&
            !state.fechaPedido.length
        ) {
            state.disableDeleteFilters = true
        } else {
            state.disableDeleteFilters = false
        }

        filtros.fecha_inicial = state.datesPedido.length ? state.datesPedido[0] : null
        filtros.fecha_final = state.datesPedido.length ? state.datesPedido[1] : null
        filtros.drive_id = state.driveSelected;

        if (state.fechaPedido) {
            if (filtros.fecha_inicial && filtros.fecha_final) {
                let f = filtros.fecha_inicial;
                if (typeof (f) == 'str') {
                    filtros.fecha_inicial = `${f.substr(6, 4)}-${f.substr(3, 2)}-${f.substr(0, 2)}`
                }
                f = filtros.fecha_final;
                if (typeof (f) == 'str') {
                    filtros.fecha_final = `${f.substr(6, 4)}-${f.substr(3, 2)}-${f.substr(0, 2)}`
                }
            }
        }

        if (filtros.fecha_inicial && filtros.fecha_final && filtros.drive_id) {
            state.cargando = true
            ReporteRequest.ReporteMerma(filtros).then(response => {
                state.encabezado = response.data.length > 0 ? response.data.shift().encabezado : {};
                state.arrResultado = response.data;

                const pageSize = state.pageSize;
                state.total = state.arrResultado.length;
                state.arrResultadoVista = state.arrResultado.filter((item, index) => {
                    if (pageSize > index) {
                        return true;
                    }
                })
                state.cargando = false;

                state.tiposMerma = [
                    { id: 1, name: 'Merma Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 2, name: 'Merma Producto Terminado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 3, name: 'Mermas Consumo Empleado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 4, name: 'Mermas App Móvil', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 5, name: 'Mermas UberEats', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 6, name: 'Mermas Capacitación Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 7, name: 'Mermas Capacitación Producto Terminado (PT)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 8, name: 'Merma Lavado Equipo', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 9, name: 'Mermas Rappi (RAPPI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 10, name: 'Mermas Degustación (DEGU)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 11, name: 'Mermas Didi (DIDI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                    { id: 12, name: 'Merma Entrega Cliente (INSMEC)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false }
                ];
                for (let index = 0; index < state.tiposMerma.length; index++) {
                    //const element = state.tiposMerma[index];
                    state.tiposMerma[index].open = false;
                    state.tiposMerma[index].detail = response.data.filter(obj => obj.tipoMerma === state.tiposMerma[index].id);
                    state.tiposMerma[index].conteo = state.tiposMerma[index].detail.length;
                    state.tiposMerma[index].costoTotal = state.tiposMerma[index].detail.reduce((accumulator, product) => {
                        return accumulator + (product.costoTotal);
                    }, 0);
                    let arrRecetas = state.tiposMerma[index].detail.filter(obj => obj.descripcion !== "");
                    let arrFolSAP = state.tiposMerma[index].detail.filter(obj => obj.folioSAP === "");

                    if (arrFolSAP.length > 0 && !state.esBarra)
                        state.tiposMerma[index].SAP = true;

                    if (arrRecetas.length > 0) {
                        const key = 'recetaKey';
                        state.tiposMerma[index].recetas = [...new Map(state.tiposMerma[index].detail.map(item => [item[key], {
                            fecha: item['fecha'],
                            numDoc: item['numDoc'],
                            descripcion: item['descripcion'],
                            empleado: item['empleado'],
                            folioSAP: item['folioSAP'],
                            tipoMerma: item['tipoMerma'],
                            recetaKey: item[key]
                        }])).values()];
                        /**
                        descripcion :  "Latt Frío Moka Blanc DF soya 32 Oz"
                                empleado :  "Ivan Eduardo Vidal Miranda"
                                fecha :  "2025-10-10T10:36:53.643000-07:00"
                                folioSAP :  "4900007827"
                                numDoc :  "CAPPT31510102501" 
                        
                            */

                        for (let indexY = 0; indexY < state.tiposMerma[index].recetas.length; indexY++) {
                            state.tiposMerma[index].recetas[indexY].open = false;
                            state.tiposMerma[index].recetas[indexY].detail = state.tiposMerma[index].detail.filter(obj => obj.recetaKey === state.tiposMerma[index].recetas[indexY].recetaKey);
                            state.tiposMerma[index].recetas[indexY].conteo = state.tiposMerma[index].recetas[indexY].detail.length;
                            state.tiposMerma[index].recetas[indexY].costoTotal = state.tiposMerma[index].recetas[indexY].detail.reduce((accumulator, product) => {
                                return accumulator + (product.costoTotal);
                            }, 0);
                        }
                    }
                }

                this.setState(state)
            }).catch(err => {
                console.error('error >>>>>><<', err)
                openNotification("Ocurrió un error al realizar los filtrados", "Error", false);
                this.setState({ cargando: false })
            })
        }else{
            this.setState({tiposMerma : [
                { id: 1, name: 'Merma Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 2, name: 'Merma Producto Terminado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 3, name: 'Mermas Consumo Empleado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 4, name: 'Mermas App Móvil', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 5, name: 'Mermas UberEats', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 6, name: 'Mermas Capacitación Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 7, name: 'Mermas Capacitación Producto Terminado (PT)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 8, name: 'Merma Lavado Equipo', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 9, name: 'Mermas Rappi (RAPPI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 10, name: 'Mermas Degustación (DEGU)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 11, name: 'Mermas Didi (DIDI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 12, name: 'Merma Entrega Cliente (INSMEC)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false }
            ]});
        }
    }

    /**
     * Se ejecuta cuando se van a borrar filtrados
     */
    deleteFilters = () => {
        this.setState({tiposMerma : []});
        let state = { ...this.state };
        state.filterTextPedidos = '';
        state.estatusSelected = undefined;
        state.fechaPedido = [];
        state.fechaVencimiento = [];
        state.datesPedido = [];
        state.datesVencimiento = [];
        state.disableDeleteFilters = true;
        state.arrResultadoVista = [];
        state.arrResultado = [];
        state.total = 0;
        state.driveSelected = null;

        state.tiposMerma = [
            { id: 1, name: 'Merma Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 2, name: 'Merma Producto Terminado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 3, name: 'Mermas Consumo Empleado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 4, name: 'Mermas App Móvil', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 5, name: 'Mermas UberEats', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 6, name: 'Mermas Capacitación Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 7, name: 'Mermas Capacitación Producto Terminado (PT)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 8, name: 'Merma Lavado Equipo', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 9, name: 'Mermas Rappi (RAPPI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 10, name: 'Mermas Degustación (DEGU)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 11, name: 'Mermas Didi (DIDI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
            { id: 12, name: 'Merma Entrega Cliente (INSMEC)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false }
        ];

        state.fechaPedido = [moment(), moment()];
        state.datesPedido = [moment(), moment()];

        setTimeout(() => {
            state.fechaPedido = [];
            state.datesPedido = [];
            this.setState(state);
        }, 50);
    }

    handleChangeDrive = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.driveSelected = null;
            state.arrResultado = [];
        } else {
            state.driveSelected = value
        }
        this.setState(state, this.applyFilters);
    }

    limpiarTabla(){
        this.setState({tiposMerma : []});

        setTimeout(() => {
            this.setState({tiposMerma : [
                { id: 1, name: 'Merma Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 2, name: 'Merma Producto Terminado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 3, name: 'Mermas Consumo Empleado', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 4, name: 'Mermas App Móvil', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 5, name: 'Mermas UberEats', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 6, name: 'Mermas Capacitación Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 7, name: 'Mermas Capacitación Producto Terminado (PT)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 8, name: 'Merma Lavado Equipo', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 9, name: 'Mermas Rappi (RAPPI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 10, name: 'Mermas Degustación (DEGU)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 11, name: 'Mermas Didi (DIDI)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false },
                { id: 12, name: 'Merma Entrega Cliente (INSMEC)', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [], SAP: false }
            ]});
        }, 150);
    }

    descargarReporte = async () => {
        let state = { ...this.state };

        const timestamp = new Date().getTime();
        const driveObj = state.arrDrives.find(obj => obj.id === state.driveSelected);
        const fileName = `Mermas_${driveObj?.nombre || "Desconocido"}_${timestamp}`;

        const filtros = {
            fecha_inicial: state.datesPedido.length ? state.datesPedido[0] : null,
            fecha_final: state.datesPedido.length ? state.datesPedido[1] : null,
            drive_id: state.driveSelected,
        };

        // Construcción de datos
        const datos = [];
        const indicesTipoMerma = [];
        const indicesHeaders = [];
        const indicesRed = [];

        state.tiposMerma.forEach((obj) => {
            if(obj.id!=12 || !state.esBarra){
                datos.push({ Col2: "", Col3: "", Col4: "", Col5: "", Col6: "", Col7: "", Col8: "", Col9: "", tipoMerma: true, level: 0 });
                indicesTipoMerma.push(datos.length);

                datos.push({ Col1: obj.name, Col2: "Documento", Col3: "Descripción", Col4: "Empleado", Col5: "Artículo", Col6: "Unidad", Col7: "Cantidad", Col8: "Costo Unitario", Col9: "Costo Total", isHeader: true, level: 0 });
                indicesHeaders.push(datos.length);

                datos.push({ Col1: "Fecha", Col2: "Documento", Col3: "Descripción", Col4: "Empleado", Col5: "Artículo", Col6: "Unidad", Col7: "Cantidad", Col8: "Costo Unitario", Col9: "Costo Total", isInfoRow: true, level: 1 });

                if (obj.recetas?.length > 0) {
                    obj.recetas.forEach((dtlR) => {
                        if(state.esBarra)
                            datos.push({ Col1: dtlR.fecha, Col2: dtlR.numDoc, Col3: dtlR.descripcion, Col4: dtlR.empleado, Col5: "", Col6: "", Col7: dtlR.conteo, Col8: "", Col9: dtlR.costoTotal, level: 1 });
                        else
                            datos.push({ Col1: dtlR.fecha, Col2: dtlR.numDoc, Col3: dtlR.descripcion, Col4: dtlR.empleado, Col5: "", Col6: "", Col7: "", Col8: "", Col9: dtlR.costoTotal, level: 1 });
                        if(dtlR.detail[0].folioSAP == "" && !state.esBarra)
                            indicesRed.push(datos.length);
                        dtlR.detail.forEach((recDtl) => {
                            datos.push({ Col1: "", Col2: "", Col3: "", Col4: "", Col5: `${recDtl.codigo} - ${recDtl.articulo}`, Col6: recDtl.unidad, Col7: recDtl.cantidad, Col8: recDtl.costo, Col9: recDtl.costoTotal, level: 2 });
                            if(dtlR.folioSAP == "" && !state.esBarra)
                                indicesRed.push(datos.length);
                        });
                    });
                } else {
                    obj.detail.forEach((dtl) => {
                        datos.push({ Col1: dtl.fecha, Col2: dtl.numDoc, Col3: "", Col4: dtl.empleado, Col5: `${dtl.codigo} - ${dtl.articulo}`, Col6: dtl.unidad, Col7: dtl.cantidad, Col8: dtl.costo, Col9: dtl.costoTotal, level: 1 });
                        if(dtl.folioSAP == "" && !state.esBarra)
                            indicesRed.push(datos.length);
                    });
                }

                //datos.push({ Col1: "", Col2: "", Col3: "", Col4: "", Col5: "", Col6: "", Col7: "", Col8: "", Col9: "", isSpacer: true, level: 1 });
                datos.push({ Col1: "", Col2: "", Col3: "", Col4: "", Col5: "", Col6: "", Col7: "", Col8: "", Col9: "", isSpacer: true, level: 1 });
            }
        });
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Historial");

        worksheet.addRow([]);
        worksheet.columns = [
            { header: "Tipo Merma / Fecha", key: "Col1", width: 23 },
            { header: "Documento", key: "Col2", width: 18 },
            { header: "Descripción", key: "Col3", width: 28 },
            { header: "Empleado", key: "Col4", width: 23 },
            { header: "Artículo", key: "Col5", width: 40 },
            { header: "Unidad", key: "Col6", width: 9 },
            { header: "Cantidad", key: "Col7", width: 12 },
            { header: "Costo Unitario", key: "Col8", width: 14 },
            { header: "Costo Total", key: "Col9", width: 14 },
        ];

        //worksheet.addRows(datos);

        // Add rows and set outline level
        datos.forEach(data => {
            const row = worksheet.addRow(data);
            // Set the outline level for the row
            row.outlineLevel = data.level;
            if (data.level !== 0)
                row.hidden = true;
        });

        // Título
        worksheet.mergeCells("A1:I1");
        const cellTitulo = worksheet.getCell("A1");
        cellTitulo.value = `Reporte de Mermas del ${filtros.fecha_inicial || "??"} al ${filtros.fecha_final || "??"}`;
        cellTitulo.font = { name: "Calibri", size: 16, color: { argb: "FFFFFFFF" }, bold: true };
        cellTitulo.alignment = { horizontal: "center", vertical: "middle" };
        cellTitulo.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E90FF" } };
        worksheet.getRow(1).height = 24;

        // Header global
        const headerRow = worksheet.getRow(2);
        headerRow.font = { name: "Calibri", bold: true, color: { argb: "FFFFFFFF" } };
        headerRow.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell) => {
            if (cell.value) {
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E90FF" } };
                cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
            }
        });

        worksheet.views = [{ state: "frozen", xSplit: 1, ySplit: 2 }];

        const startDataRow = 3;
        const endDataRow = worksheet.rowCount;

        // Formato general
        for (let r = startDataRow; r <= endDataRow; r++) {
            const row = worksheet.getRow(r);
            row.height = 18;
            row.eachCell({ includeEmpty: true }, (cell) => {
                cell.border = { top: { style: "hair" }, left: { style: "hair" }, bottom: { style: "hair" }, right: { style: "hair" } };
            });
            row.getCell("G").numFmt = '#,##0.00';
            row.getCell("H").numFmt = '$#,##0.00';
            row.getCell("I").numFmt = '$#,##0.00';
        }


        indicesTipoMerma.forEach((dataIdx) => {
            const rowNumber = dataIdx + 2; // Ajuste por título y encabezado global
            const tituloMerma = worksheet.getRow(rowNumber).getCell(1).value; // Texto original

            // Combinar celdas A:I
            worksheet.mergeCells(`A${rowNumber}:I${rowNumber}`);
            const cell = worksheet.getCell(`A${rowNumber}`);
            cell.value = tituloMerma;

            // Estilo del título del tipo de merma
            cell.font = { name: "Calibri", size: 14, bold: true, color: { argb: "FFFFFFFF" } }; // Texto blanco
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2F75B5" } }; // Azul oscuro
            cell.border = {
                top: { style: "medium" },
                left: { style: "medium" },
                bottom: { style: "medium" },
                right: { style: "medium" },
            };

            worksheet.getRow(rowNumber).height = 28; // Más alto para destacar
            //worksheet.getRow(rowNumber + 1, rowNumber + 10).outlineLevel = 1;
        });


        // Pintar headers internos
        indicesHeaders.forEach((dataIdx) => {
            const rowNumber = dataIdx + 2;
            const row = worksheet.getRow(rowNumber);

            const isHeader = row.getCell(2).value === "Documento"


            if (isHeader) {
                row.eachCell({ includeEmpty: true }, (cell) => {
                    cell.font = { name: "Calibri", bold: true, color: { argb: "FFFFFFFF" } };
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF3B92C6" } };
                    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
                    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
                });
                row.height = 20;
            }

        });

        indicesHeaders.forEach((dataIdx) => {
            const firstDetailRowNumber = dataIdx + 3; // header + 1
            const row = worksheet.getRow(firstDetailRowNumber);
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } }; // blanco
                cell.font = { name: "Calibri", size: 11, color: { argb: "FF000000" } };
                cell.alignment = { vertical: "middle", horizontal: colNumber >= 7 ? "right" : "left" };
            });
        });
        

        // Pintar headers internos
        indicesRed.forEach((dataIdx) => {
            const rowNumber = dataIdx+1;
            const row = worksheet.getRow(rowNumber);

            const isHeader = row.getCell(7).value !== ""

            if (isHeader) {
                row.eachCell({ includeEmpty: true }, (cell) => {
                    cell.font = { bold: true };
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF1958B" } };
                });
            }
        });

        worksheet.pageSetup = {
            paperSize: 9,
            orientation: "landscape",
            fitToPage: true,
            fitToWidth: 1,
            fitToHeight: 0,
            margins: { left: 0.3, right: 0.3, top: 0.5, bottom: 0.5, header: 0.2, footer: 0.2 },
        };

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), fileName + ".xlsx");
        
        /*
        {
                Col1: "Tipo Merma",
                Col2: "",
                Col3: "",
                Col4: "",
                Col5: "",
                Col6: "",
                Col7: "Cantidad de Articulos",
                Col8: "",
                Col9: "Costo Total",
            }
        for (let index = 0; index < this.state.tiposMerma.length; index++) {
            datos.push({
                Col1 : this.state.tiposMerma[index]
            })
        }*/


        /*
        { id: 1, name: 'Merma Materia Prima', costoTotal: 0, conteo: 0, open: false, detail: [], recetas: [] },
    
        <td>{moment(item.fecha).format("DD/MM/YYYY, h:mm a")}</td>
                                            <td>{item.numDoc}</td>
                                            <td colSpan="2">{item.empleado}</td>
                                            <td>{item.codigo + " - " + item.articulo}</td>
                                            <td>{item.unidad}</td>
                                            <td style={{textAlign: "right"}}>{item.cantidad}</td>
                                            <td style={{textAlign: "right"}}>{this.props.currencyFormat(item.costo)}</td>
                                            <td style={{textAlign: "right"}}>{this.props.currencyFormat(item.costoTotal)}</td>
    
        let state = { ...this.state }
        this.setState({cargandoExcel:true});
        setTimeout(() => {
            
            let drive = state.driveSelected != null ? state.arrDrives.filter(element => state.driveSelected == element.id)[0].nombre : 'TODOS';
            let dia_actual = moment(new Date()).format("DD/MM/YYYY")
     
            const fecha_inicial = state.datesPedido.length ? state.datesPedido[0] : null
            const fecha_final = state.datesPedido.length ? state.datesPedido[1] : null
            
            let datos_variables = {
                'Drive': drive,
                'Periodo': fecha_inicial +' - '+fecha_final,
                'Día de reporte': dia_actual,
            }
     
            var wb = new Excel.Workbook();
            var ws = wb.addWorksheet('Reporte de mermas');
     
            const fontStyle = {
                name: 'Arial',
                color: { argb: 'FFFFFFFF' },
                bold: true,
                size: 12
            }
            const alignmentStyle = {
                vertical: 'middle',
                horizontal: 'center'
            }
            const borderStyle = {
                top: { color: { rgb: '110, 105, 105' } },
                left: { color: { rgb: '110, 105, 105' } },
                bottom: { color: { rgb: '110, 105, 105' } },
                right: { color: { rgb: '110, 105, 105' } }
            }
            const fillStyle = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '506e6969' }
            }
            const styleFormat = {
                font: fontStyle,
                alignment: alignmentStyle,
                border: borderStyle,
                fill: fillStyle
            }
            const styleFormatEncabezado = {
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'e3e3e3' }
                }
            }
     
                ws.mergeCells('D1', 'D2');
                ws.mergeCells('E1', 'E2');
                ws.mergeCells('F1', 'F2');
                ws.mergeCells('G1', 'G2');
                ws.mergeCells('H1', 'H2');
                ws.mergeCells('I1', 'I2');
                ws.mergeCells('J1', 'J2');
                ws.mergeCells('K1', 'K2');
                ws.mergeCells('L1', 'L2');
                ws.mergeCells('M1', 'M2');
     
                ws.columns = [
                    { key: 'A', width: 20 },
                    { key: 'B', width: 25 },
                    { key: 'C', width: 5 },
                    { header: 'Fecha', key: 'Fecha', width: 30 },
                    { header: 'Drive', key: 'Drive', width: 30 },
                    { header: 'GP', key: 'NumDocGP', width: 30 },
                    { header: 'Empleado', key: 'Empleado', width: 30 },
                    { header: 'Código inventario', key: 'CodigoInventario', width: 30 },
                    { header: 'Artículo', key: 'Articulo', width: 30 },
                    { header: 'Cantidad', key: 'Cantidad', width: 30 },
                    { header: 'Unidad', key: 'Unidad', width: 30 },
                    { header: 'Costo unitario', key: 'CostoUnitario', width: 30 },
                    { header: 'Costo total', key: 'CostoTotal', width: 30 },
                ]
     
                ws.getRow(1).height = 20;
                ws.getCell('D1').style = styleFormat;
                ws.getCell('E1').style = styleFormat;
                ws.getCell('F1').style = styleFormat;
                ws.getCell('G1').style = styleFormat;
                ws.getCell('H1').style = styleFormat;
                ws.getCell('I1').style = styleFormat;
                ws.getCell('J1').style = styleFormat;
                ws.getCell('K1').style = styleFormat;
                ws.getCell('L1').style = styleFormat;
                ws.getCell('M1').style = styleFormat;
     
     
            let rowsAgroup = []
            if(state.tipoConsultaSelected == 0) {
                let index = 0;
                for (const element of state.arrResultado) {
                    const fecha = element.encabezado.Fecha
                    const rowCreate = ws.addRow({
                        Fecha:fecha.substring(8,10)+'/'+fecha.substring(5,7)+'/'+fecha.substring(0,4)+' '+fecha.substring(11,13)+':'+fecha.substring(14,16),
                        Drive:element.encabezado.Drive,
                        NumDocGP:element.encabezado.NumDocGP,
                        Empleado:element.encabezado.Empleado,
                        CodigoInventario:'',
                        Articulo:'...',
                        Cantidad:element.encabezado.Cantidad.toFixed(3),
                        Unidad:'',
                        CostoUnitario:'...',
                        CostoTotal:'$'+element.encabezado.CostoTotal.toFixed(3),
                    });
                    rowsAgroup.push(rowCreate.number);
                    rowCreate.getCell(`D`).style = styleFormatEncabezado;
                    rowCreate.getCell(`E`).style = styleFormatEncabezado;
                    rowCreate.getCell(`F`).style = styleFormatEncabezado;
                    rowCreate.getCell(`G`).style = styleFormatEncabezado;
                    rowCreate.getCell(`H`).style = styleFormatEncabezado;
                    rowCreate.getCell(`I`).style = styleFormatEncabezado;
                    rowCreate.getCell(`J`).style = styleFormatEncabezado;
                    rowCreate.getCell(`K`).style = styleFormatEncabezado;
                    rowCreate.getCell(`L`).style = styleFormatEncabezado;
                    rowCreate.getCell(`M`).style = styleFormatEncabezado;
                    // let indx = 1;
                    element.detalle.forEach((itemDetalle,indx) => {
                        ws.addRow({
                            Fecha:fecha.substring(8,10)+'/'+fecha.substring(5,7)+'/'+fecha.substring(0,4)+' '+fecha.substring(11,13)+':'+fecha.substring(14,16),
                            Drive:element.encabezado.Drive,
                            NumDocGP:element.encabezado.NumDocGP,
                            Empleado:element.encabezado.Empleado,
                            CodigoInventario:itemDetalle.CodigoInventario,
                            Articulo:itemDetalle.Articulo,
                            Cantidad:itemDetalle.Cantidad,
                            Unidad:itemDetalle.Unidad,
                            CostoUnitario:itemDetalle.CostoUnitario,
                            CostoTotal:itemDetalle.CostoTotal
                        });
                        ws.getCell(`J${index+3}`).numFmt = '0.000';
                        ws.getCell(`L${index+4+indx}`).numFmt = '$0.000';
                        ws.getCell(`M${index+4+indx}`).numFmt = '$0.000';
                        // indx++;
                    });
                    index++;
                };
            } else {
                let index = 0;
                for (const element of state.arrResultado) {            
                    
     
                    const rowCreate = ws.addRow({
                        Fecha:'...',
                        Drive:element.encabezado.Drive,
                        NumDocGP:'...',
                        Empleado:'...',
                        CodigoInventario:element.encabezado.CodigoInventario,
                        Articulo:element.encabezado.Articulo,
                        Cantidad:element.encabezado.Cantidad,
                        Unidad:element.encabezado.Unidad,
                        CostoUnitario:element.encabezado.CostoUnitario,
                        CostoTotal:element.encabezado.CostoTotal,
                    });
                    ws.getCell(`J${index+3}`).numFmt = '0.000';
                    ws.getCell(`L${index+3}`).numFmt = '$0.000';
                    ws.getCell(`M${index+3}`).numFmt = '$0.000';
                    rowsAgroup.push(rowCreate.number);
                    rowCreate.getCell(`D`).style = styleFormatEncabezado;
                    rowCreate.getCell(`E`).style = styleFormatEncabezado;
                    rowCreate.getCell(`F`).style = styleFormatEncabezado;
                    rowCreate.getCell(`G`).style = styleFormatEncabezado;
                    rowCreate.getCell(`H`).style = styleFormatEncabezado;
                    rowCreate.getCell(`I`).style = styleFormatEncabezado;
                    rowCreate.getCell(`J`).style = styleFormatEncabezado;
                    rowCreate.getCell(`K`).style = styleFormatEncabezado;
                    rowCreate.getCell(`L`).style = styleFormatEncabezado;
                    rowCreate.getCell(`M`).style = styleFormatEncabezado;
                    // let indx = 1;
                    
                    element.detalle.forEach((itemDetalle,indx)  => {
                        ws.addRow({
                            Fecha:itemDetalle.Fecha.substring(8,10)+'/'+itemDetalle.Fecha.substring(5,7)+'/'+itemDetalle.Fecha.substring(0,4)+' '+itemDetalle.Fecha.substring(11,13)+':'+itemDetalle.Fecha.substring(14,16),
                            Drive:itemDetalle.Drive,
                            NumDocGP:itemDetalle.NumDocGP,
                            Empleado:itemDetalle.Empleado,
                            CodigoInventario:itemDetalle.CodigoInventario,
                            Articulo:itemDetalle.Articulo,
                            Cantidad:itemDetalle.Cantidad,
                            Unidad:itemDetalle.Unidad,
                            CostoUnitario:itemDetalle.CostoUnitario,
                            CostoTotal:itemDetalle.CostoTotal
                        });
                        ws.getCell(`J${index+3}`).numFmt = '0.000';
                        ws.getCell(`L${index+4+indx}`).numFmt = '$0.000';
                        ws.getCell(`M${index+4+indx}`).numFmt = '$0.000';
                        // indx++;
                    });
                    index++;
                };
            }
     
            // for (let index = 0; index < rowsAgroup.length; index++) {
            //     if(index != 0){
            //         const rowIndexAnterior = rowsAgroup[index-1];
            //         const rowIndexActual = rowsAgroup[index];
            //         // ws.getRange(`${rowIndexAnterior+1}:${rowIndexActual-1}`).group(Excel.GroupOption.byRows);
            //     }
                
            // }
            let indice_row = 1;  // Contador para los renglones del archivo.
            Object.entries(datos_variables).forEach(arr => {
                ws.getRow(indice_row).getCell(1).value = arr[0];
                ws.getCell(`A${indice_row}`).style = styleFormat;
                ws.getRow(indice_row).getCell(2).value = arr[1];
                indice_row += 1;
            })
    
            indice_row += 2; 
            ws.getRow(indice_row).getCell(1).value = 'Descripción';
            ws.getRow(indice_row).getCell(1).style = styleFormat;
            ws.getRow(indice_row).getCell(2).value = 'Total';
            ws.getRow(indice_row).getCell(2).style = styleFormat;
            indice_row += 1;
            if(this.state.encabezado){
                Object.keys(this.state.encabezado).forEach(key => {
                    ws.getRow(indice_row).getCell(1).value = (key=='CostoTotal' ? 'Costo total' : key == 'Cantidad' ? 'Cantidad recibida': key)+': ';
                    ws.getRow(indice_row).getCell(2).value =(key != 'Cantidad' ? '$' :'')+ this.state.encabezado[key].toFixed(3);
                    indice_row += 1;
                });
            }
     
            wb.creator = 'Inventario';
            wb.title = `Archivo para ver el reporte de mermas`;
     
            wb.xlsx.writeBuffer()
                .then(buffer => {
                    var data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    saveAs(data, `Reporte de mermas.xlsx`);
                })
            this.setState({cargandoExcel:false});
        }, 200);
        */
    }

    onChangePagination = (page, size) => {
        let state = { ...this.state };
        const inicio = (page * size) - size;
        const fin = (page * size);
        state.arrResultadoVista = [];
        state.arrResultadoVista = state.arrResultado.filter((item, index) => {
            if (index >= inicio && index < fin) {
                return true;
            }
        });
        window.scrollTo(0, 0);
        this.setState(state);
    }

    toggleRow = (item) => {
        if (item.detail.length > 0) {
            let state = { ...this.state }
            let { tiposMerma } = state;
            let itemEditado = tiposMerma.find(({ id }) => { return id === item.id })
            itemEditado.open = !item.open;
            if (!itemEditado.open) {
                for (let index = 0; index < itemEditado.recetas.length; index++) {
                    itemEditado.recetas[index].open = false;
                }
            }
            //setExpandedRowId(expandedRowId === id ? null : id);
            this.setState({ ...state, tiposMerma });
        }
    };

    toggleRowReceta = (item) => {
        if (item.detail.length > 0) {
            let state = { ...this.state }
            let { tiposMerma } = state;
            let itemEditado = tiposMerma.find(({ id }) => { return id === item.tipoMerma })
            let itemRecetaEditado = itemEditado.recetas.find(({ recetaKey }) => { return recetaKey === item.recetaKey })
            itemRecetaEditado.open = !item.open;
            //setExpandedRowId(expandedRowId === id ? null : id);
            this.setState({ ...state, tiposMerma });
        }
    };

    currencyFormat(num) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    render() {
        return (
            <Spin tip="Exportando a excel..."
                indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                spinning={this.state.cargandoExcel}
                style={{ color: "black", backgroundColor: "rgb(255,255,255,0.8)" }}>
                <Card id=""
                    title="Reporte de mermas"
                    extra={
                        <div>
                            <Button id="boton-descargar-pedidos perfectos-excel"
                                type="primary"
                                style={{ marginRight: 20 }}
                                disabled={!this.state.arrResultado.length}
                                onClick={() => {
                                    this.descargarReporte()
                                }}
                            >  Descargar reporte  </Button>
                        </div>
                    }
                >
                    <div className="panel-block">
                        <Spin tip="Cargando filtros..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargandoFiltros}
                            style={{ color: "black", backgroundColor: "rgb(255,255,255,0.8)" }}>
                            <Row gutter={{lg: 16, md: 24}}>
                                <Col lg={6} md={10} style={{ paddingBottom: '10px' }}>
                                    <div className="center">
                                        {
                                            this.state.esBarra ? "Barra:" : "Drive:"
                                        }
                                    </div>
                                    <Tooltip
                                        placement="top"
                                        title={this.state.esBarra ? "Seleccione una barra" : "Seleccione un drive"}>
                                        <Select id="select-plaza-calendario-modulo"
                                            showSearch
                                            style={{ width: "100%" }}
                                            allowClear={!(this.state.roles.length == 1 && this.state.roles.includes('Operador'))}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeDrive}
                                            value={this.state.driveSelected}
                                            disabled={this.state.cargando}
                                        >
                                            <Option value={null} disabled={true} >Seleccionar...</Option>
                                            {
                                                this.state.arrDrives.length > 0 &&
                                                this.state.arrDrives.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}
                                                            disabled={obj.disable}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                                <Col lg={6} md={10} style={{ paddingBottom: '10px' }} >
                                    <Tooltip placement="top" title="Seleccione periodo">
                                        <div className="center">Periodo:</div>
                                        <RangePicker
                                            format={dateFormat}
                                            placeholder={["Fecha Inicio", "Fecha Fin"]}
                                            value={this.state.fechaPedido}
                                            disabled={this.state.cargando}
                                            ranges={{
                                                'Hoy': [moment(), moment()],
                                                'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                                'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()]
                                            }}
                                            onOpenChange={(open) => {
                                                if (open) {
                                                    this.setState({ firstDate: null })
                                                }
                                            }}
                                            disabledDate={(current) => {
                                                let state = { ...this.state }
                                                let firstDateClone = moment(JSON.parse(JSON.stringify(state.firstDate)));
                                                return state.firstDate ? state.firstDate > current || current > firstDateClone.add(31, 'day') : false;
                                            }}
                                            onCalendarChange={(dates, dateStrings, info) => {
                                                const firstDate = dates[0];
                                                let firstDateClone = moment(JSON.parse(JSON.stringify(firstDate)));
                                                this.setState({ firstDate: firstDate, fechaPedido: [firstDate, firstDateClone.add(31, 'day')] });
                                            }}
                                            onChange={(dates, dateStrings) => {
                                                let state = { ...this.state }
                                                if (dates.length == 0 && state.fechaPedido.length != 0) {
                                                    state.fecha_inicial = moment();
                                                    state.fecha_final = moment();
                                                    state.fechaPedido = [moment(), moment()];
                                                    state.datesPedido = [moment(), moment()];
                                                    this.setState(state);
                                                    setTimeout(() => {
                                                        state.fechaPedido = [];
                                                        state.datesPedido = [];
                                                        this.setState(state);
                                                    }, 500);
                                                } else {
                                                    const diasDiferencia = dates[1].diff(dates[0], 'days')
                                                    if (diasDiferencia > 31) {
                                                        openNotification(
                                                            "El rango de fechas no debe de exceder más de 31 días.",
                                                            "Aviso"
                                                        )
                                                        this.setState({ fechaPedido: dates, datesPedido: dateStrings });
                                                    } else {
                                                        this.setState({ fechaPedido: dates, datesPedido: dateStrings, filterTextPedidos: "" }, () => {
                                                            this.applyFilters();
                                                        });
                                                    }

                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </Col>
                                <Col lg={2} md={4} >
                                    <div>
                                        <Tooltip placement="top" title="Borrar filtros">
                                            <Button size='large' type="default" icon="delete" className={this.state.disableDeleteFilters ? 'disableBtn' : ''} style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.1em' }} onClick={this.deleteFilters}></Button>
                                        </Tooltip>
                                    </div>
                                </Col>
                            </Row>
                            <Row className={this.state.arrResultado.length > 0 ? '' : 'display-none'} style={{ paddingBottom: "10px", fontWeight: 'bold' }}>
                                {this.state.encabezado && Object.keys(this.state.encabezado).map((key) => (
                                    <Col span={6} style={{ paddingRight: '5px', paddingTop: '5px' }}>
                                        <div style={{ padding: '2rem', display: 'grid', backgroundColor: '#b4b3b394', textAlign: 'center', borderRadius: '3rem' }}>
                                            <span>{(key == 'CostoTotal' ? 'Costo total' : key == 'Cantidad' ? 'Cantidad recibida' : key) + ': '}</span>
                                            <span>{`${key != 'Cantidad' ? '$' : ''}` + this.state.encabezado[key].toFixed(3)}</span>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Spin>
                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                            {
                                <div className="ant-table ant-table-small ant-table-scroll-position-left">
                                    <div className="ant-table-content">
                                        <div className="ant-table-body">
                                            <table className='ant-table table'>
                                                <thead className="ant-table-thead">
                                                    <tr style={{ textAlign: "center", fontSize: "16px" }}>
                                                        <th colSpan="2">Tipo Merma</th>
                                                        <th colSpan="2"></th>
                                                        <th style={{ textAlign: "right" }}>{ this.state.esBarra ? 'Total de Articulos': ''}</th>
                                                        <th colSpan="2" ></th>
                                                        <th colSpan="2" style={{ textAlign: "right" }}>Costo Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="ant-table-tbody">
                                                    {this.state.tiposMerma.map((item) => (
                                                        <React.Fragment key={item.id}>
                                                            <tr onClick={() => this.toggleRow(item)} style={{ backgroundColor: "#9edafaff", fontSize: "14px", fontWeight: "bold", color: item.SAP ? '#E74C3C' : "000000ff", display: item.id!=12 || !this.state.esBarra ? 'table-row' : 'none'}}>
                                                                <td colSpan="2">{item.name}</td>
                                                                <td colSpan="2"></td>
                                                                <td style={{ textAlign: "right" }}>{this.state.esBarra ? item.conteo: ''}</td>
                                                                <td colSpan="2" ></td>
                                                                <td colSpan="2" style={{ textAlign: "right" }}>{this.currencyFormat(item.costoTotal)}</td>
                                                            </tr>
                                                            {item.open && (
                                                                <MyTable
                                                                    esBarra={this.state.esBarra}
                                                                    currencyFormat={this.currencyFormat}
                                                                    toggleRowReceta={this.toggleRowReceta}
                                                                    tipoMerma={item} />
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Spin>
                    </div>
                </Card>
            </Spin>
        )
    }
}

export default Form.create()(Mermas);